import React from "react";
import AnyQuestions from "../../reusable/AnyQuestions";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
class Cart extends React.Component {
  _handleLoginCheckout = () => {
    const { auth } = this.props;
    if (auth.isAuthenticated) {
      this.context.router.history.push("/checkout");
    }
    this.context.router.history.push("/login");
  };
  render() {
    return (
      <section className="cart-buy-con">
        <div className="container">
          <div className="row">
            <div className="col-md-6 cart-buy-left">
              <div className="cart-buy-picture row">
                <img
                  className="img-responsive"
                  src="/images/wi-fi-img.jpg"
                  alt="wifi"
                />
              </div>
              <div className="cart-buy-heading row">
                <h2>MightyWiFi</h2>
                <h3>Your 4G LTE Global WiFi Hotspot</h3>
                <h4>$149.99</h4>
                <p>
                  <strong>Save up to 95% on international data roaming.</strong>
                  Travel the world with super fast mobile WiFi connectivity and
                  power for all your gadgets. Hassle-free - unlimited, fast,
                  secure internet at one low, flat rate worldwide.
                </p>
                <p>
                  <Link to="/">What's in the box?</Link>
                </p>
              </div>
            </div>

            <div className="col-md-6 cart-buy-right">
              <div className="cart-heading">
                <h2>Cart</h2>
                <div className="cart-main-price">
                  <span className="product-name">MIGHTYWIFI</span>
                  <span className="product-name">
                    <select>
                      <option value="number">1</option>
                      <option value="one">2</option>
                      <option value="two">3</option>
                      <option value="three">4</option>
                    </select>
                  </span>
                  <span className="product-price">$149.99</span>
                </div>
                <div className="cart-main-price-off">
                  <span className="day-pass-title">DAY PASS - FREE</span>
                  <span className="day-pass-price">$9.99</span>
                </div>
                <div className="dis-apply">
                  <span className="day-pass-title">
                    <input type="text" placeholder="DISCOUNT CODE" />
                  </span>
                  <span className="day-pass-price">
                    <button>APPLY</button>
                  </span>
                </div>
                <div className="total-price">
                  <span className="total-price-left">TOTAL</span>
                  <span className="total-price-right">$149.99</span>
                </div>
                <div className="checkout">
                  <button>PROCEED TO CHECKOUT</button>
                </div>
                <p className="tax-ship">
                  Tax and shipping applied at checkout.
                </p>
                <div className="pay-cards">
                  <p>All major credit cards accepted</p>
                  <div className="cards">
                    <img src="/images/pay-cards.png" alt="card" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <AnyQuestions />
        </div>
      </section>
    );
  }
}

Cart.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default connect(mapStateToProps)(Cart);



// WEBPACK FOOTER //
// ./src/pages/buy/Cart.js